import { render } from "./About.vue?vue&type=template&id=2ab2b380"
const script = {}

import exportComponent from "C:\\Users\\erwin\\Dropbox\\My Projects\\JavaScript\\Vue\\vuemastery\\real-world-vue-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__